import { render, staticRenderFns } from "./MFAInput.vue?vue&type=template&id=5e732002&scoped=true"
import script from "./MFAInput.vue?vue&type=script&lang=js"
export * from "./MFAInput.vue?vue&type=script&lang=js"
import style0 from "./MFAInput.vue?vue&type=style&index=0&id=5e732002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e732002",
  null
  
)

export default component.exports